type HsqCommand = unknown[];

declare global {
  interface Window {
    _hsq?: HsqCommand[];
  }
}

const HS_NO_COLLECT_ATTR = "data-hs-do-not-collect";
const HUBSPOT_SCRIPT_ID = "hs-script-loader";
const HUBSPOT_SCRIPT_SRC = "https://js-ap1.hs-scripts.com/441784197.js";

const isLocalhost = () =>
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

/** Loads HubSpot only after main.tsx has removed private bearers from the URL. */
export function loadHubSpotScript() {
  if (typeof window === "undefined" || isLocalhost()) return;
  if (document.getElementById(HUBSPOT_SCRIPT_ID)) return;

  const script = document.createElement("script");
  script.type = "text/javascript";
  script.id = HUBSPOT_SCRIPT_ID;
  script.async = true;
  script.defer = true;
  script.src = HUBSPOT_SCRIPT_SRC;
  document.body.appendChild(script);
}

function isHubSpotOwnForm(form: HTMLFormElement): boolean {
  if (form.closest("#hubspot-form-container")) return true;
  const cls = form.className || "";
  return /\bhs-form\b|\bhsForm\b|\bhbspt-form\b/.test(cls);
}

/** Only HubSpot-native embeds should be scraped. App forms sync via hubspot-handler API. */
function shouldBeCollected(form: HTMLFormElement): boolean {
  return isHubSpotOwnForm(form);
}

function tagForm(form: HTMLFormElement) {
  if (shouldBeCollected(form)) return;
  if (!form.hasAttribute(HS_NO_COLLECT_ATTR)) {
    form.setAttribute(HS_NO_COLLECT_ATTR, "true");
  }
}

function tagAllForms(root: ParentNode) {
  root
    .querySelectorAll?.("form")
    .forEach((el) => tagForm(el as HTMLFormElement));
}

let observerStarted = false;

export function initHubSpotNoCollect() {
  if (observerStarted || typeof document === "undefined") return;
  observerStarted = true;

  tagAllForms(document);

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;
        if (node.tagName === "FORM") {
          tagForm(node as HTMLFormElement);
        } else {
          tagAllForms(node);
        }
      });
    }
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener("DOMContentLoaded", () => {
      tagAllForms(document);
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
}

export function identifyContact(
  email: string,
  properties: Record<string, string | number | boolean> = {},
) {
  if (typeof window === "undefined" || !email) return;
  window._hsq = window._hsq || [];
  window._hsq.push(["identify", { email, ...properties }]);
  window._hsq.push(["trackPageView"]);
}

export function trackEvent(
  eventName: string,
  properties: Record<string, string | number | boolean> = {},
) {
  if (typeof window === "undefined") return;
  window._hsq = window._hsq || [];
  window._hsq.push([
    "trackCustomBehavioralEvent",
    { name: eventName, properties },
  ]);
}
